module.exports = __webpack_public_path__ + "img/on.53a48d84.svg";